import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CountdownTimer from '../../membership/components/CountdownTimer';
import { useCart } from '../../../contexts/CartContext';

function applyDiscount(price: string): string {
  const num = parseFloat(price.replace(/[$,]/g, ''));
  const discounted = Math.floor(num * 0.85);
  return '$' + discounted.toLocaleString();
}

export default function TreatmentsGrid() {
  const [timerExpired, setTimerExpired] = useState(false);
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const treatments = [
    {
      id: 'treatment-hydration',
      name: 'Hydration',
      price: '$209',
      description: 'Pure replenishment for ultimate baseline wellness.',
      ingredients: 'Electrolytes, B-Complex, Vitamin C',
      isPremium: false,
      image: 'https://public.readdy.ai/ai/img_res/4ca457276a2f2f48c9f8d650f5d73564.jpg',
    },
    {
      id: 'treatment-hangover',
      name: 'Hangover Relief',
      price: '$299',
      description: 'Fast detox, nausea relief, and re-energize after nights out.',
      ingredients: 'Ondansetron, B-Complex, Magnesium, Electrolytes',
      isPremium: false,
      image: 'https://readdy.ai/api/search-image?query=transparent%20medical%20grade%20IV%20drip%20bag%20filled%20with%20golden%20yellow%20vitamin%20fluid%20with%20dark%20black%20rectangular%20label%20panel%20printed%20with%20white%20text%20IV%20HYDRATION%20CLUB%20and%20treatment%20name%20hanging%20against%20pure%20white%20studio%20background%20professional%20product%20photography%20clean%20minimalist%20lighting%20medical%20equipment%20with%20clear%20tubing%20attached&width=480&height=640&seq=ivbag_hangover_club_01&orientation=portrait',
    },
    {
      id: 'treatment-headache',
      name: 'Headache Relief',
      price: '$399',
      description: 'Targeted relief for migraines and tension headaches.',
      ingredients: 'Magnesium, B-Complex, Anti-inflammatory blend',
      isPremium: false,
      image: 'https://readdy.ai/api/search-image?query=transparent%20medical%20grade%20IV%20drip%20bag%20filled%20with%20soft%20lavender%20purple%20fluid%20with%20dark%20black%20rectangular%20label%20panel%20printed%20with%20white%20text%20IV%20HYDRATION%20CLUB%20and%20treatment%20name%20hanging%20against%20pure%20white%20studio%20background%20professional%20product%20photography%20clean%20minimalist%20lighting%20medical%20equipment%20with%20clear%20tubing%20attached&width=480&height=640&seq=ivbag_headache_club_01&orientation=portrait',
    },
    {
      id: 'treatment-immunity',
      name: 'Immunity',
      price: '$349',
      description: 'Boost defenses with high-dose vitamins and antioxidants.',
      ingredients: 'Vitamin C, Zinc, Glutathione',
      isPremium: false,
      image: 'https://readdy.ai/api/search-image?query=transparent%20medical%20grade%20IV%20drip%20bag%20filled%20with%20vibrant%20orange%20vitamin%20C%20fluid%20with%20dark%20black%20rectangular%20label%20panel%20printed%20with%20white%20text%20IV%20HYDRATION%20CLUB%20and%20treatment%20name%20hanging%20against%20pure%20white%20studio%20background%20professional%20product%20photography%20clean%20minimalist%20lighting%20medical%20equipment%20with%20clear%20tubing%20attached&width=480&height=640&seq=ivbag_immunity_club_01&orientation=portrait',
    },
    {
      id: 'treatment-jetlag',
      name: 'Jet Lag',
      price: '$389',
      description: 'Reset circadian rhythm and combat travel fatigue.',
      ingredients: 'B12, Magnesium, Amino Acids, Electrolytes',
      isPremium: false,
      image: 'https://readdy.ai/api/search-image?query=transparent%20medical%20grade%20IV%20drip%20bag%20filled%20with%20teal%20turquoise%20aqua%20fluid%20with%20dark%20black%20rectangular%20label%20panel%20printed%20with%20white%20text%20IV%20HYDRATION%20CLUB%20and%20treatment%20name%20hanging%20against%20pure%20white%20studio%20background%20professional%20product%20photography%20clean%20minimalist%20lighting%20medical%20equipment%20with%20clear%20tubing%20attached&width=480&height=640&seq=ivbag_jetlag_club_01&orientation=portrait',
    },
    {
      id: 'treatment-beauty',
      name: 'Beauty IV',
      price: '$399',
      description: 'Glow from within with skin, hair, and nail support.',
      ingredients: 'Biotin, Glutathione, Vitamin C, Collagen boosters',
      isPremium: true,
      image: 'https://readdy.ai/api/search-image?query=transparent%20medical%20grade%20IV%20drip%20bag%20filled%20with%20soft%20pink%20rose%20fluid%20with%20dark%20black%20rectangular%20label%20panel%20printed%20with%20white%20text%20IV%20HYDRATION%20CLUB%20and%20treatment%20name%20hanging%20against%20pure%20white%20studio%20background%20professional%20product%20photography%20clean%20minimalist%20lighting%20medical%20equipment%20with%20clear%20tubing%20attached&width=480&height=640&seq=ivbag_beauty_club_01&orientation=portrait',
    },
    {
      id: 'treatment-fitness',
      name: 'Fitness Recovery',
      price: '$329',
      description: 'Muscle repair, reduced soreness, faster bounce-back.',
      ingredients: 'Amino Acids, Magnesium, B-Complex',
      isPremium: false,
      image: 'https://readdy.ai/api/search-image?query=transparent%20medical%20grade%20IV%20drip%20bag%20filled%20with%20deep%20red%20crimson%20fluid%20with%20dark%20black%20rectangular%20label%20panel%20printed%20with%20white%20text%20IV%20HYDRATION%20CLUB%20and%20treatment%20name%20hanging%20against%20pure%20white%20studio%20background%20professional%20product%20photography%20clean%20minimalist%20lighting%20medical%20equipment%20with%20clear%20tubing%20attached&width=480&height=640&seq=ivbag_fitness_club_01&orientation=portrait',
    },
    {
      id: 'treatment-flu',
      name: 'Flu Treatment',
      price: '$399',
      description: 'Combat symptoms and speed recovery from illness.',
      ingredients: 'Vitamin C, Zinc, B-Complex, Electrolytes',
      isPremium: false,
      image: 'https://readdy.ai/api/search-image?query=transparent%20medical%20grade%20IV%20drip%20bag%20filled%20with%20warm%20amber%20honey%20fluid%20with%20dark%20black%20rectangular%20label%20panel%20printed%20with%20white%20text%20IV%20HYDRATION%20CLUB%20and%20treatment%20name%20hanging%20against%20pure%20white%20studio%20background%20professional%20product%20photography%20clean%20minimalist%20lighting%20medical%20equipment%20with%20clear%20tubing%20attached&width=480&height=640&seq=ivbag_flu_club_01&orientation=portrait',
    },
    {
      id: 'treatment-myers',
      name: 'Myers Cocktail',
      price: '$299',
      description: 'Classic vitamin-mineral blend for energy and vitality.',
      ingredients: 'Magnesium, Calcium, B-Complex, Vitamin C',
      isPremium: false,
      image: 'https://readdy.ai/api/search-image?query=transparent%20medical%20grade%20IV%20drip%20bag%20filled%20with%20bright%20golden%20yellow%20vitamin%20cocktail%20fluid%20with%20dark%20black%20rectangular%20label%20panel%20printed%20with%20white%20text%20IV%20HYDRATION%20CLUB%20and%20treatment%20name%20hanging%20against%20pure%20white%20studio%20background%20professional%20product%20photography%20clean%20minimalist%20lighting%20medical%20equipment%20with%20clear%20tubing%20attached&width=480&height=640&seq=ivbag_myers_club_01&orientation=portrait',
    },
    {
      id: 'treatment-nad500',
      name: 'NAD 500mg',
      price: '$699',
      description: 'Cellular repair, anti-aging, and mental clarity.',
      ingredients: 'NAD+ 500mg, B-Complex',
      isPremium: true,
      image: 'https://readdy.ai/api/search-image?query=transparent%20medical%20grade%20IV%20drip%20bag%20filled%20with%20clear%20platinum%20silver%20fluid%20with%20dark%20black%20rectangular%20label%20panel%20printed%20with%20white%20text%20IV%20HYDRATION%20CLUB%20and%20treatment%20name%20hanging%20against%20pure%20white%20studio%20background%20professional%20product%20photography%20clean%20minimalist%20lighting%20premium%20medical%20equipment%20with%20clear%20tubing%20attached&width=480&height=640&seq=ivbag_nad500_club_01&orientation=portrait',
    },
    {
      id: 'treatment-nad1000',
      name: 'NAD 1000mg',
      price: '$899',
      description: 'Maximum cellular regeneration and cognitive enhancement.',
      ingredients: 'NAD+ 1000mg, B-Complex, Amino Acids',
      isPremium: true,
      image: 'https://readdy.ai/api/search-image?query=transparent%20medical%20grade%20IV%20drip%20bag%20filled%20with%20luminous%20crystal%20clear%20champagne%20fluid%20with%20dark%20black%20rectangular%20label%20panel%20printed%20with%20white%20text%20IV%20HYDRATION%20CLUB%20and%20treatment%20name%20hanging%20against%20pure%20white%20studio%20background%20professional%20product%20photography%20clean%20minimalist%20lighting%20ultra%20premium%20medical%20equipment%20with%20clear%20tubing%20attached&width=480&height=640&seq=ivbag_nad1000_club_01&orientation=portrait',
    },
    {
      id: 'treatment-postsurgery',
      name: 'Post Surgery',
      price: '$349',
      description: 'Support healing and reduce inflammation after procedures.',
      ingredients: 'Vitamin C, Zinc, Amino Acids, Anti-inflammatory',
      isPremium: false,
      image: 'https://readdy.ai/api/search-image?query=transparent%20medical%20grade%20IV%20drip%20bag%20filled%20with%20soft%20mint%20green%20healing%20fluid%20with%20dark%20black%20rectangular%20label%20panel%20printed%20with%20white%20text%20IV%20HYDRATION%20CLUB%20and%20treatment%20name%20hanging%20against%20pure%20white%20studio%20background%20professional%20product%20photography%20clean%20minimalist%20lighting%20medical%20equipment%20with%20clear%20tubing%20attached&width=480&height=640&seq=ivbag_postsurgery_club_01&orientation=portrait',
    },
    {
      id: 'treatment-foodpoison',
      name: 'Food Poisoning',
      price: '$299',
      description: 'Rapid rehydration and symptom relief.',
      ingredients: 'Ondansetron, Electrolytes, B-Complex',
      isPremium: false,
      image: 'https://readdy.ai/api/search-image?query=transparent%20medical%20grade%20IV%20drip%20bag%20filled%20with%20clear%20light%20blue%20electrolyte%20fluid%20with%20dark%20black%20rectangular%20label%20panel%20printed%20with%20white%20text%20IV%20HYDRATION%20CLUB%20and%20treatment%20name%20hanging%20against%20pure%20white%20studio%20background%20professional%20product%20photography%20clean%20minimalist%20lighting%20medical%20equipment%20with%20clear%20tubing%20attached&width=480&height=640&seq=ivbag_foodpoison_club_01&orientation=portrait',
    },
  ];

  const semaglutideOptions = [
    {
      id: 'sema-1month',
      supply: '1 Month Supply',
      description: 'Transforming weight care at the source',
      price: '$279',
      badge: null,
    },
    {
      id: 'sema-3month',
      supply: '3 Month Supply',
      description: 'Transforming weight care at the source',
      price: '$596',
      badge: 'Most Popular',
    },
    {
      id: 'sema-6month',
      supply: '6 Month Supply',
      description: 'Transforming weight care at the source',
      price: '$1,050',
      badge: 'Best Value',
    },
  ];

  const handleAddTreatmentToCart = (treatment: typeof treatments[0]) => {
    addToCart({
      id: treatment.id,
      name: treatment.name,
      type: 'vitamin',
      ivCount: treatment.ingredients,
      price: treatment.price,
      period: 'per session',
      features: [treatment.description],
      discountedPrice: !timerExpired ? applyDiscount(treatment.price) : undefined,
    });
    navigate('/cart');
  };

  const handleAddSemaToCart = (option: typeof semaglutideOptions[0]) => {
    addToCart({
      id: option.id,
      name: `Semaglutide — ${option.supply}`,
      type: 'vitamin',
      ivCount: option.description,
      price: option.price,
      period: 'supply',
      features: [option.description],
      discountedPrice: !timerExpired ? applyDiscount(option.price) : undefined,
    });
    navigate('/cart');
  };

  return (
    <section className="py-24 px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center">
          <p className="text-greige text-lg font-light leading-relaxed max-w-3xl mx-auto">
            All drips administered by licensed RNs in private, luxurious suites. Customize with add-ons to create your perfect wellness experience.
          </p>
        </div>

        {/* IV Treatments Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {treatments.map((treatment, index) => (
            <div
              key={index}
              id={treatment.id}
              className="bg-white border border-[#e8e2da] rounded-none overflow-hidden group hover:shadow-lg transition-all duration-400 flex flex-col"
            >
              {/* IV Bag Image */}
              <div className="relative bg-white flex items-center justify-center pt-10 pb-6 px-8" style={{ minHeight: '320px' }}>
                <img
                  src={treatment.image}
                  alt={treatment.name}
                  className="w-auto object-contain group-hover:scale-105 transition-transform duration-500"
                  style={{ maxHeight: '280px', maxWidth: '100%' }}
                />
              </div>

              {/* Card Content */}
              <div className="flex flex-col flex-1 items-center text-center px-8 pb-8 pt-2">
                <h3 className="text-sm font-normal text-charcoal tracking-[0.2em] uppercase mb-2">
                  {treatment.name}
                </h3>

                {/* Price with discount logic */}
                <div className="mb-3">
                  {!timerExpired ? (
                    <div className="flex flex-col items-center gap-1">
                      <div className="flex items-center gap-2">
                        <span className="text-base font-light text-greige line-through">
                          {treatment.price}
                        </span>
                        <span className="text-[10px] bg-gold/20 text-gold border border-gold/40 rounded-full px-2 py-0.5 font-light tracking-wide whitespace-nowrap">
                          15% OFF
                        </span>
                      </div>
                      <span className="text-xl font-light text-charcoal">
                        {applyDiscount(treatment.price)}
                      </span>
                    </div>
                  ) : (
                    <p className="text-xl font-light text-charcoal">
                      {treatment.price}
                    </p>
                  )}
                </div>

                <p className="text-greige text-sm font-light leading-relaxed mb-6 flex-1">
                  {treatment.description}
                </p>

                {/* Discount message + timer above button */}
                <div className="w-full mb-3">
                  {!timerExpired ? (
                    <>
                      <p className="text-center text-xs font-light text-charcoal/70 mb-2">
                        If you book within 10 minutes, get 15% off
                      </p>
                      <div className="mb-3">
                        <CountdownTimer onExpire={() => setTimerExpired(true)} compact />
                      </div>
                    </>
                  ) : (
                    <p className="text-center text-xs font-light text-greige mb-3">
                      Limited-time offer expired
                    </p>
                  )}
                </div>

                <button
                  onClick={() => handleAddTreatmentToCart(treatment)}
                  className="w-full py-3 border border-charcoal text-charcoal text-xs font-light tracking-[0.15em] uppercase hover:bg-charcoal hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
                >
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Semaglutide Section */}
        <div className="mt-24">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1 bg-gold/20 text-gold text-xs tracking-widest uppercase rounded-full mb-4">
              Weight Management
            </span>
            <h2 className="text-4xl md:text-5xl font-light text-charcoal tracking-wide mb-4">
              Compounded Semaglutide (GLP-1)
            </h2>
            <p className="text-greige text-lg font-light max-w-2xl mx-auto leading-relaxed">
              Transforming weight care at the source — clinician-supervised injections for sustainable, meaningful results.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {semaglutideOptions.map((option, index) => (
              <div
                key={index}
                className={`relative rounded-2xl p-10 text-center transition-all duration-400 hover:shadow-xl hover:-translate-y-1 group ${
                  option.badge === 'Most Popular'
                    ? 'bg-charcoal text-white border-2 border-gold'
                    : 'bg-bone border border-[#e8e2da]'
                }`}
              >
                {option.badge && (
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                    <span className={`px-4 py-1 text-xs font-light tracking-widest uppercase rounded-full whitespace-nowrap ${
                      option.badge === 'Most Popular'
                        ? 'bg-gold text-white'
                        : 'bg-gold text-white'
                    }`}>
                      {option.badge}
                    </span>
                  </div>
                )}

                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-6">
                  <i className={`ri-syringe-line text-3xl ${option.badge === 'Most Popular' ? 'text-gold' : 'text-charcoal'}`}></i>
                </div>

                <h3 className={`text-2xl font-normal tracking-wide mb-2 ${option.badge === 'Most Popular' ? 'text-white' : 'text-charcoal'}`}>
                  {option.supply}
                </h3>
                <p className={`text-sm font-light mb-6 leading-relaxed ${option.badge === 'Most Popular' ? 'text-white/70' : 'text-greige'}`}>
                  Of Injections — {option.description}
                </p>

                {/* Price with discount logic */}
                <div className="mb-8">
                  {!timerExpired ? (
                    <div className="flex flex-col items-center gap-1">
                      <div className="flex items-center justify-center gap-2">
                        <span className={`text-2xl font-light line-through opacity-50 ${option.badge === 'Most Popular' ? 'text-white' : 'text-greige'}`}>
                          {option.price}
                        </span>
                        <span className="text-xs bg-gold/20 text-gold border border-gold/40 rounded-full px-2 py-0.5 font-light tracking-wide whitespace-nowrap">
                          15% OFF
                        </span>
                      </div>
                      <span className="text-5xl font-light text-gold">
                        {applyDiscount(option.price)}
                      </span>
                    </div>
                  ) : (
                    <p className="text-5xl font-light text-gold">
                      {option.price}
                    </p>
                  )}
                </div>

                {/* Discount message + timer above button */}
                <div className="mb-4">
                  {!timerExpired ? (
                    <>
                      <p className={`text-center text-xs font-light mb-2 ${option.badge === 'Most Popular' ? 'text-white/80' : 'text-charcoal/70'}`}>
                        If you book within 10 minutes, get 15% off
                      </p>
                      <div className="mb-3">
                        <CountdownTimer onExpire={() => setTimerExpired(true)} compact />
                      </div>
                    </>
                  ) : (
                    <p className={`text-center text-xs font-light mb-3 ${option.badge === 'Most Popular' ? 'text-white/50' : 'text-greige'}`}>
                      Limited-time offer expired
                    </p>
                  )}
                </div>

                <button
                  onClick={() => handleAddSemaToCart(option)}
                  className={`inline-block w-full py-3 text-sm font-light tracking-wide rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    option.badge === 'Most Popular'
                      ? 'bg-gold text-white hover:bg-gold/90'
                      : 'border border-charcoal text-charcoal hover:bg-charcoal hover:text-white'
                  }`}
                >
                  Add to Cart
                </button>
              </div>
            ))}
          </div>

          <p className="text-center text-greige text-xs font-light mt-8 max-w-2xl mx-auto leading-relaxed">
            Compounded Semaglutide is prescribed and supervised by licensed clinicians. Results may vary. Not suitable for all individuals.
          </p>
        </div>

        <div className="text-center mt-16">
          <button
            onClick={() => navigate('/cart')}
            className="inline-block px-12 py-4 bg-charcoal text-white text-base font-light tracking-wide rounded-full hover:bg-charcoal/90 hover:scale-105 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
          >
            View Cart &amp; Book Session
          </button>
        </div>
      </div>
    </section>
  );
}
